import { EmptyState, ErrorBoundary, FlexBox } from '@dixa/lib-shared-habla';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { NotFoundView } from '../notFound';

import { AnalyticsView } from './analytics.view';
import { DashboardView } from './views/dashboard';
import { AnalyticsFeedbackView } from './views/feedback/analyticsFeedback.view';
import { QuickViewView } from './views/quickView';
import { QuickViewsView } from './views/quickViews';

export const AnalyticsRoutes = (): JSX.Element => {
  const flags = useFeatureFlag(['custom-analytics']);

  if (!flags.customAnalytics) {
    return (
      <Routes>
        <Route
          path="*"
          element={<NotFoundView navigatePath="/dashboard" name="Dashboard" />}
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="*"
        element={
          <ErrorBoundary
            fallback={
              <FlexBox
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <EmptyState
                  title="Something went wrong"
                  description="Analytics is currently unavailable due to an unexpected
                  error. Our team has been notified and is looking into the
                  issue."
                  icon="exclamation"
                  iconColor="red.500"
                  buttonProps={{
                    variant: 'primary',
                    children: 'Try reloading',
                    onClick: () => window.location.reload(),
                  }}
                />
              </FlexBox>
            }
          >
            <AnalyticsView>
              <Routes>
                <Route index element={<Navigate to="dashboard" replace />} />

                <Route path="dashboard">
                  <Route index element={<DashboardView />} />

                  <Route path=":slug" element={<DashboardView />}>
                    <Route
                      path="feedback"
                      element={<AnalyticsFeedbackView />}
                    />
                  </Route>
                </Route>

                <Route
                  path="dashboard/:slug/quick-view/:id"
                  element={<QuickViewView />}
                />

                <Route path="quick-views" element={<QuickViewsView />} />

                <Route
                  path="*"
                  element={<Navigate to="/analytics" replace />}
                />
              </Routes>
            </AnalyticsView>
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};
